/*************************************/
/** 								**/
/**    REGISTER & FACTORY	 		**/
/** 								**/
/*************************************/
hrd.core.ComponentFactory = hrd.Class.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.core.ComponentFactory',
			formInstance: undefined,
			verbose: false
		};
		this._super($.extend(true, {}, defaults, options));
		this.repository = {};
	},
	factory: function(name, type, mode) {
		mode = mode || 'edit';
		let component;
		let key = this.toKey(name, type, mode);
		let componentClass = componentRegistryInstance.retrieveClass(type, mode);
		if(componentClass) {
			component = this.repository[key];
			if(component == undefined) {
				this.log(`Creating instance for component "${type}" for field "${name}" in mode "${mode}"`);
				let componentImpl = $.evaluate(componentClass.component);
				let options = {
					name: name, 
					type: type, 
					mode: mode, 
					prefix: name, 
					formInstance: this.settings.formInstance,
					reference: this.settings.formInstance.settings.reference
				};
				component = $.evaluate('new impl(options)', window, [componentImpl, options], ['impl', 'options']);
				this.repository[key] = component;
			} else {
				this.log(`Component "${type}" for field "${name}" in mode "${mode}" is already available`);
			}
		} else {
			this.log(`Component "${type}" for field "${name}" in mode "${mode}" is NOT buildable`);
			return undefined;
		}
		return component;
	},
	toKey: function(name, type, mode) {
		return `${name}-${type}-${mode}`;
	},
	clearAll: function() {
		this.repository = [];
	},
	clearKey: function(name, type, mode) {
		let key = this.toKey(name, type, mode);
		if(this.repository[key] != undefined) {
			delete this.repository[key];
		}
	},
	log: function() {
		if(this.settings.verbose) {
			console.log.apply(window, arguments);
		}
	}
});

//window.formElementFactory = (type, mode) => formElementRegister.factory(type, mode);